import React, { useContext, useState, useRef } from 'react';
import { WeatherContext } from '../../core/WeatherDataContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faGear } from '@fortawesome/free-solid-svg-icons';
import './TopBar.css';
import CitySetting from '../CitySetting/CitySetting';

interface TopBarProps {
    // Define your component's props here
}

const TopBarComponent: React.FC<TopBarProps> = () => {
    const context = useContext(WeatherContext);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const refreshButtonRef = useRef<HTMLDivElement>(null);

    const refreshData = () => {
        context?.refresh();
        setIsRefreshing(true);
        setTimeout(() => setIsRefreshing(false), 2000);
    };

    const openSettings = () => {
        setIsSettingsOpen(true);
    };

    const closeSettings = () => {
        setIsSettingsOpen(false);
    };

    const citySettings = context?.value?.map((data) => {
        return <CitySetting key={data.getName()} name={data.getName()}></CitySetting>
    });
    const lastUpdate = localStorage.getItem('lastUpdate') || '0';
    const date = new Date(parseInt(lastUpdate, 10) * 1000);

    return (
        <div className="box top-bar">
            <div ref={refreshButtonRef}>
                <FontAwesomeIcon 
                    size='2x' 
                    icon={faRefresh} 
                    onClick={refreshData}
                    className={isRefreshing ? 'spinner' : ''}
                />
            </div>
            <div className="columns is-gapless has-text-centered last-update">
                <span className="column is-size-7">Última atualização</span>
                <span className="column is-size-7">{date.toLocaleString()}</span>
            </div>
            <FontAwesomeIcon size='2x' icon={faGear} onClick={openSettings}></FontAwesomeIcon>
            <div className={`modal ${isSettingsOpen ? 'is-active' : ''}`}>
                <div className="modal-background" onClick={closeSettings}></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Selecionar Cidades</p>
                    </header>
                    <section className="modal-card-body">
                        {citySettings}
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button" onClick={closeSettings}>Fechar</button>
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default TopBarComponent;
